import { gql } from '@/__generated__';

const UPDATE_DEVICE_CALIBRATION = gql(`
  mutation UpdateDeviceCalibration($input: UpdateDeviceCalibrationInput!) {
    updateDeviceCalibration(input: $input) {
      deviceId
      calibration {
        level
      }
    }
  }
`);

export default UPDATE_DEVICE_CALIBRATION;
